import React, {useState, useEffect} from 'react';
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";

/**
 * Component to show provisioning progress with a countdown timer
 * @param {Object} props - Component props
 * @param {number} props.timeoutSeconds - Number of seconds before timeout
 */
const ProvisioningProgressIndicator = ({nodeType, timeoutSeconds = 30, clusterStatus = undefined}) => {
    const [secondsLeft, setSecondsLeft] = useState(timeoutSeconds);
    
    // Countdown timer effect
    useEffect(() => {
        // Reset timer when component mounts
        setSecondsLeft(timeoutSeconds);
        
        // Set up interval to decrement timer
        const intervalId = setInterval(() => {
            setSecondsLeft(prevSeconds => {
                if (prevSeconds <= 1) {
                    clearInterval(intervalId);
                    return 0;
                }
                return prevSeconds - 1;
            });
        }, 1000);
        
        // Clean up interval on unmount
        return () => clearInterval(intervalId);
    }, [timeoutSeconds]);
    
    return (
        <Row style={{marginBottom: '15px'}}>
            <div style={{
                width: '100%',
                padding: '8px',
                backgroundColor: '#00A8E1', // Blue for in-progress
                color: '#FFFFFF',
                borderRadius: '4px',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            }}>
                {/* Progress bar */}
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    height: '3px',
                    backgroundColor: '#B6E3FF',
                    width: `${(secondsLeft / timeoutSeconds) * 100}%`,
                    transition: 'width 1s linear'
                }}></div>
                
                {/* Loading spinner */}
                <div style={{
                    width: '16px',
                    height: '16px',
                    border: '3px solid rgba(255,255,255,0.3)',
                    borderRadius: '50%',
                    borderTopColor: '#FFFFFF',
                    animation: 'spin 1s linear infinite',
                    marginRight: '10px'
                }}></div>
                
                {/* Animation keyframes */}
                <style>{`
                    @keyframes spin {
                        to { transform: rotate(360deg); }
                    }
                `}</style>
                
                {/* Status text with countdown */}
                {!clusterStatus && (
                    <Text color="inverse">
                        {nodeType} Provisioning in Progress - Waiting for Response...
                        ({secondsLeft}s remaining)
                    </Text>
                )}
            </div>
        </Row>
    );
};

export default ProvisioningProgressIndicator;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/ProvisioningProgressIndicator.js